import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { useForm } from "react-hook-form";
import { PlantillaCorreoService } from "../../service/admin/PlantillaCorreoService";
import { InputComponent } from "../../components/InputComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Card } from "primereact/card";
import { PlantillaCorreo } from "../../models/administracion/PlantillaCorreo";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { EmpresaService } from "../../service/EmpresaService";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { useLazyParams } from "../../hooks/useLazyParams";
import { TablaDinamica } from "../../components/TablaDinamica";
import { Divider } from "primereact/divider";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";
import { FormActionButtons } from "../../components/ui/FormActionButtons";
import { Sidebar } from "primereact/sidebar";
import { Tooltip } from "primereact/tooltip";

const variablesDisponibles = [
    { variable: '@nombre', descripcion: 'Nombre completo del cliente / consumidor.', aplica: 'Contenido', ejemplo: 'Juan Pérez' },
    { variable: '@usuario', descripcion: 'Login o identificador de acceso del usuario.', aplica: 'Contenido', ejemplo: '@PRO0928374651-1' },
    { variable: '@formulario', descripcion: 'Nombre del catálogo/tipo de formulario asignado.', aplica: 'Contenido', ejemplo: 'Cliente Persona Natural' },
    { variable: '@empresa', descripcion: 'Nombre de la empresa que envía la notificación.', aplica: 'Asunto y Contenido', ejemplo: 'PRELAFIT' },
    { variable: '@ambiente', descripcion: 'Indica " - AMBIENTE DE PRUEBAS" o vacío en producción.', aplica: 'Asunto y Contenido', ejemplo: ' - AMBIENTE DE PRUEBAS' },
    { variable: '@clave', descripcion: 'Contraseña temporal/generada para el acceso.', aplica: 'Contenido', ejemplo: 'Ab8#kL92!z' },
    { variable: '@fechaMaxima', descripcion: 'Fecha límite permitida para llenar el formulario.', aplica: 'Contenido', ejemplo: '2025-05-15' },
    { variable: '@link', descripcion: 'URL frontal del sistema donde accederá el usuario.', aplica: 'Contenido', ejemplo: 'https://app.midominio.com' },
    { variable: '@observacion', descripcion: 'Comentarios u observaciones adicionales.', aplica: 'Contenido', ejemplo: 'Por favor no adjuntar documentos en blanco' },
    { variable: '@logo', descripcion: 'URL de la imagen del logo de la empresa.', aplica: 'Contenido (HTML)', ejemplo: 'https://dominio.com/logo.png' },
    { variable: '@correo_usuario', descripcion: 'Correo del usuario que despacha/notifica.', aplica: 'Contenido', ejemplo: 'oficial@empresa.com' },
    { variable: '@nombre_remitente', descripcion: 'Nombre del usuario que despacha/notifica.', aplica: 'Contenido', ejemplo: 'Carlos Mendoza' },
];

export const PlanCorreo = () => {
    const generic = new GenericComponent();
    const omodel = new PlantillaCorreo();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const plantillaService = new PlantillaCorreoService();
    const empresaService = new EmpresaService();
    const [plantilla, setPlantilla] = useState(null);
    const [contenido, setContenido] = useState(null);
    const [selectedEmp, setSelectedEmp] = useState(null);
    const [emp, setEmp] = useState(null);
    const [dialogPlantilla, setDialogPlantilla] = useState(false);
    const toast = useRef(null);
    const menuRef = useRef(null);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const { inAutocomplete, inText, inDrop } = InputComponent({ omodel, errors, control, permss, id: getValues('id') });
    const [visibleSidebarVariables, setVisibleSidebarVariables] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };

        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        plantillaService.getItem({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    };

    const openNew = () => {
        setPlantilla(null);
        setContenido(null);
        setDialogPlantilla(true);
        reset(defaultValues);
    };

    const onSubmit = (data) => {
        setIsSaving(true);
        data.contenido = contenido;
        const request = getValues('id') == null ? plantillaService.nuevo(data) : plantillaService.editar(data);
        request.then(res => {
            generic.funcSuccess(res, toast);
            setDialogPlantilla(false);
            loadLazyData();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    };

    const editPlantilla = () => {
        plantillaService.consultar(plantilla?.id).then(res => {
            const _plantilla = res.data.correo;
            setSelectedEmp(_plantilla.empresa);
            setContenido(_plantilla.contenido);

            reset(generic.renewValues(_plantilla, omodel.model));
            setDialogPlantilla(true);
        });
    };

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la plantilla?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    };

    const eliminar = () => {
        plantillaService.eliminar(plantilla.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    };

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar) items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editPlantilla() });
        if (permss?.eliminar) items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete() });

        return [{ label: 'Opciones', items: items }];
    };

    const searchEmp = (event) => {
        if (!event.query.trim().length) {
            setEmp([...emp]);
        } else {
            empresaService.consultarEmpresaNombre(event.query.toLowerCase()).then(data => {
                setEmp(data);
            });
        }
    };

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones"
                aria-controls="popup_menu" aria-haspopup onClick={(event) => { setPlantilla(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    const dialogHeaderTemplate = () => {
        return (
            <div className="flex align-items-center">
                <span className="font-bold text-xl">
                    {getValues('id') == null ? "Nueva plantilla" : "Editar plantilla"}
                </span>
                <i className="pi pi-question-circle ml-2 cursor-pointer text-white hover:text-cyan-200 transition-colors"
                    style={{ fontSize: '1.25rem' }} id="btn-ayuda-variables" onClick={() => setVisibleSidebarVariables(true)} />
                <Tooltip target="#btn-ayuda-variables" content="Ver variables disponibles (@)" position="top" />
            </div>
        );
    };

    const footerModal = (
        <FormActionButtons formId="form-plantilla" onCancel={setDialogPlantilla} isSaving={isSaving} className="pt-2" />
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo', permss)} />
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>

            <Dialog visible={dialogPlantilla} header={dialogHeaderTemplate} modal className="p-fluid modal-ssize dialog-personalizado"
                onHide={() => setDialogPlantilla(false)} style={{ width: '90vw', maxWidth: '850px' }} footer={footerModal}
                breakpoints={{ '960px': '85vw', '641px': '100vw' }}>
                <form id="form-plantilla" onSubmit={handleSubmit(onSubmit)} className="mt-2">
                    <div className="formgrid grid">
                        {inText('nombre', { icon: 'pi pi-bookmark' }, 8)}
                        {inDrop('estado', generic.sino, { lab: omodel.optionLabel }, 4)}
                        {inText('asunto', { icon: 'pi pi-envelope' }, 8)}
                        {inText('nemonico', { icon: 'pi pi-tag' }, 4)}
                        {inText('mailer', { icon: 'pi pi-send' }, 6)}
                        {inText('url_banner', { icon: 'pi pi-image' }, 6)}
                        {inAutocomplete('empresa', selectedEmp, setSelectedEmp, emp, searchEmp, { lab: omodel.optionLabel, noEsActividad: true, col: 12 })}

                        <div className="col-12 py-1">
                            <Divider className="my-2" />
                        </div>
                        <div className="field col-12 mb-2">
                            <div className="flex align-items-center justify-content-between mb-2">
                                <label className="font-medium text-800 text-sm mb-0 flex align-items-center gap-2">
                                    <i className="pi pi-align-left text-primary" />
                                    Cuerpo del Correo (HTML)*
                                </label>
                                <small className="text-500 text-xs">
                                    Soporta formato enriquecido y etiquetas HTML
                                </small>
                            </div>

                            <div className="surface-border border-1 border-round shadow-1">
                                <Editor value={contenido} onTextChange={(e) => setContenido(e.htmlValue)} style={{ height: '300px' }} placeholder="Redacte aquí el contenido del correo electrónico..." />
                            </div>
                        </div>
                    </div>
                </form>
            </Dialog>

            <Sidebar visible={visibleSidebarVariables} position="right" onHide={() => setVisibleSidebarVariables(false)}
                baseZIndex={1200} style={{ width: '42vw', minWidth: '380px', maxWidth: '100vw' }}>
                <div className="px-2 pb-4">
                    <div className="font-bold text-800 mb-3 text-lg flex align-items-center gap-2">
                        <i className="pi pi-code text-primary text-xl"></i>
                        <span>Variables Disponibles</span>
                    </div>

                    <div className="surface-50 border-left-3 border-blue-500 p-2 mb-3 border-round-right flex align-items-center gap-2">
                        <i className="pi pi-info-circle text-blue-500 text-lg flex-shrink-0" />
                        <span className="text-700 text-sm line-height-2">
                            Las variables con <b>@</b> se reemplazarán con datos reales al enviar el correo. Revise si aplican en el Asunto o en el Contenido.
                        </span>
                    </div>

                    <DataTable value={variablesDisponibles} size="small" stripedRows showGridlines className="border-1 surface-border text-sm">
                        <Column header="Variable" body={(r) => <Tag value={r.variable} severity="info" className="font-mono text-xs px-2 py-1" />} style={{ width: '28%' }} />
                        <Column field="descripcion" header="Descripción" style={{ width: '42%', fontSize: '0.8rem' }} />
                        <Column field="ejemplo" header="Ejemplo" body={(r) => <span className="text-xs text-600 font-italic">{r.ejemplo}</span>} style={{ width: '22%' }} />
                        <Column header="Aplica en"
                            body={(r) => (
                                <span className={`text-xs font-semibold px-2 py-1 border-round ${r.aplica.includes('Asunto') ? 'bg-orange-100 text-orange-800' : 'bg-blue-50 text-blue-800'}`}>
                                    {r.aplica}
                                </span>
                            )} style={{ width: '30%', textAlign: 'center' }}
                        />
                    </DataTable>
                </div>
            </Sidebar>
        </>
    );
};